import React, { useEffect, useState } from "react";
import profile from "../../Assets/Images/undraw_profile.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import axiosHttp from "../../Config";
import ReusableModal from "../../Components/Modal";
import CreateAdmin from "../../Components/CreateAdmin";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader";
import { roleType } from "../../Constants";
import ReactPaginate from "react-paginate";
import { Modal } from "react-bootstrap";

const Admin = () => {
  const [adminList, setAdminList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [formValues, setFormValues] = useState({
    userName: "",
    role: "",
    emailId: "",
    password: "",
  });
  const [pageData, setPageData] = useState({
    currentPage: 1,
    totalPages: 1,
  });
  const [entries, setEntries] = useState(10);
  const [delModal, setDelModal] = useState(false);

  useEffect(() => {
    fetchAdminList(pageData.currentPage, entries);
  }, [pageData.currentPage, entries]);

  const fetchAdminList = async (current, count) => {
    setLoading(true);
    try {
      const getAdminList = await axiosHttp.get(
        `admin?page=${current}&per_page=${count}`
      );
      if (getAdminList.status === 200) {
        let data = getAdminList.data.data;
        let page = getAdminList.data.meta;
        setPageData({
          currentPage: page.currentPage,
          totalPages: page.lastPage,
        });
        setAdminList(data);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setAdminList([]);
      setLoading(false);
    }
  };

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setFormValues({
      userName: "",
      role: "",
      emailId: "",
      password: "",
    });
  };

  const openDelModal = () => {
    setDelModal(true);
  };

  const closeDelModal = () => {
    setDelModal(false);
  };

  const submitHandler = async () => {
    setLoading(true);
    let payload = {
      ...formValues,
      password: btoa(formValues.password),
    };
    try {
      const addAdmin = await axiosHttp.post("admin", { ...payload });
      if (addAdmin.status === 201) {
        toast.success(addAdmin.data.message);
        setShowModal(false);
        fetchAdminList(pageData.currentPage, entries);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      console.log(error);
      setLoading(false);
    }
  };

  const deleteHandler = async (id) => {
    setLoading(true);
    try {
      const deleteAdmin = await axiosHttp.delete(`admin/${id}`);
      if (deleteAdmin.status === 200) {
        setLoading(true);
        setDelModal(false);
        toast.success(deleteAdmin.data.message);
        fetchAdminList(pageData.currentPage, entries);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      console.log(error);
      setLoading(false);
    }
  };

  const handlePageClick = (event) => {
    setPageData({ ...pageData, currentPage: event.selected + 1 });
  };

  return loading ? (
    <Loader />
  ) : (
    <div className="container-fluid top-container">
      <div className="card  card-one-1 mb-5">
        <div className="card-body">
          <h4 className="title mb-5">Manage Admins</h4>
          <div className="row mb-5">
            <div className="col-md-5">
              <h5 className="head">Admins List</h5>
            </div>
            <div className="col-md-7 text-right">
              <div className="d-flex justify-content-end">
                <div className="d-flex align-items-center"></div>
                <button
                  type="button"
                  className="btn btn-primary ml-3"
                  data-toggle="modal"
                  data-target="#admin"
                  onClick={openModal}
                >
                  Create admin
                </button>
              </div>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-sm-12 col-md-6">
              <label className="d-flex align-items-center">
                Show{" "}
                <select
                  className="form-control entry-select ml-2 mr-2"
                  value={entries}
                  onChange={(e) => setEntries(Number(e.target.value))}
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                entries
              </label>
            </div>
            {/* <div className="col-sm-12 ml-auto col-md-3">
              <div className="d-flex align-items-center">
                <label className="mr-3 mb-0">Search: </label>
                <input className="form-control" />
              </div>
            </div> */}
          </div>
          <div className="table-responsive">
            <table
              className="table table-bordered"
              id="dataTable"
              width="100%"
              cellspacing="0"
            >
              <thead className="bg-col">
                <tr>
                  <th className="border-right-0 ">
                    <input
                      type="checkbox"
                      className="form-control check-box "
                    />
                  </th>
                  <th className="border-right-0 ">Admin</th>
                  <th className="border-right-0 ">Role</th>
                  <th className="border-right-0 ">Email Id</th>
                  <th className="border-right-0 ">Action</th>
                </tr>
              </thead>
              <tbody>
                {adminList.length === 0 && (
                  <p className="mt-2">No Data Available</p>
                )}
                {adminList.length > 0 &&
                  adminList.map((admin) => {
                    return (
                      <tr key={admin.id}>
                        <td className="text-center border-right-0 ">
                          <input
                            type="checkbox"
                            className="form-control check-box "
                          />
                        </td>
                        <td className="border-right-0 ">
                          <img
                            className="img-profile rounded-circle photo mr-2"
                            src={admin.pic_url ? admin.pic_url : profile}
                            alt="profile"
                          />{" "}
                          {admin?.user_name}
                        </td>
                        <td className="border-right-0 ">
                          {roleType[admin?.role]}
                        </td>
                        <td>{admin?.email_id}</td>

                        <td>
                          {/* <span>
                            <FontAwesomeIcon
                              icon={faEye}
                              className="bg-success text-white p-1 rounded mr-3 cursor-pointer"
                            />
                          </span> */}
                          {/* <span onClick={() => deleteHandler(admin.user_id)}> */}
                          <span onClick={openDelModal}>
                            <FontAwesomeIcon
                              icon={faTrashAlt}
                              className="bg-danger text-white p-1 rounded mr-3 cursor-pointer"
                            />
                          </span>
                        </td>
                        <ReusableModal
                          show={delModal}
                          onHide={closeDelModal}
                          title="Delete Admin"
                        >
                          <Modal.Body>
                            <p>Are you sure want to delete</p>
                          </Modal.Body>
                          <Modal.Footer>
                            <Modal.Footer className="justify-content-center">
                              <button
                                type="button"
                                className="btn btn-outline-primary modal-btn"
                                onClick={() => deleteHandler(admin.user_id)}
                              >
                                Delete
                              </button>
                              <button
                                type="button"
                                className="btn btn-outline-secondary modal-btn"
                                onClick={closeDelModal}
                              >
                                Cancel
                              </button>
                            </Modal.Footer>
                          </Modal.Footer>
                        </ReusableModal>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
          {pageData.totalPages > 1 && (
            <ReactPaginate
              breakLabel="..."
              nextLabel=">"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={pageData.totalPages}
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination justify-content-end"
              activeClassName="active"
              previousLabel="<"
              forcePage={pageData.currentPage - 1}
            />
          )}
        </div>
      </div>
      <ReusableModal
        show={showModal}
        onHide={closeModal}
        title="Create Admin"
        size="lg"
      >
        <CreateAdmin
          onHide={closeModal}
          formValues={formValues}
          setFormValues={setFormValues}
          submitHandler={submitHandler}
        />
      </ReusableModal>
    </div>
  );
};

export default Admin;
